import React from 'react';
import lovricanBadge from '../../assets/images/adifund/lovrican-badge.svg';
import adifundLogo from '../../assets/images/adifund/adifund-logo.svg';
import sponsorStar from '../../assets/images/adifund/sponsor-star.svg';
import infoIcon from '../../assets/images/adifund/info-icon.svg';
import '../../assets/scss/adifund.scss';

export const ADIFUND_URL = 'https://adifund.com';

/**
 * Black "Enjoy Lovrican for free — Sponsored by Adifund" card.
 * Figma: Frame 168 — 40:19890 on the homepage, 40:5209 in Settings. Both are
 * 364x363 with a 284x48 button; the ONLY difference is that the homepage
 * button carries an (i) (node 40:19924, "Group 960") and the Settings one
 * does not.
 *
 * On the homepage the whole pill is the popup trigger, not just the (i) — the
 * icon reads as a hint about what the button does rather than as a separate
 * control, and a 23px hit target inside a 284px button is easy to miss. The
 * (i) is therefore decorative here, and the pill is a <button>, not a link.
 *
 * variant="settings" drops the (i) to match 40:5199 and keeps the pill as the
 * outbound link to adifund.com, since no popup is reachable from there.
 */
const AdifundCard = ({ onInfoClick, variant = 'home', className = '' }) => (
  <div className={`adifund-card ${className}`.trim()}>
    <div className="adifund-card-inner">
      <div className="adifund-card-logos">
        <img className="adifund-logo-lovrican" src={lovricanBadge} alt="Lovrican" />
        <span className="adifund-plus">+</span>
        <span className="adifund-logo-adifund">
          <img src={adifundLogo} alt="Adifund" />
        </span>
      </div>

      <div className="adifund-card-text">
        <p className="adifund-card-eyebrow">Exclusive member benefit</p>
        <div>
          <p className="adifund-card-title">Enjoy Lovrican for free</p>
          <p className="adifund-card-sub">Exclusive access for Adifund members.</p>
        </div>
      </div>

      <div className="adifund-card-divider" />

      <div className="adifund-card-btn">
        {variant === 'settings' ? (
          <a
            className="adifund-card-btn-link"
            href={ADIFUND_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="adifund-card-btn-star" src={sponsorStar} alt="" />
            <span>Sponsored by Adifund</span>
          </a>
        ) : (
          <button
            type="button"
            className="adifund-card-btn-link"
            aria-label="Sponsored by Adifund — about this sponsorship"
            onClick={onInfoClick}
          >
            <img className="adifund-card-btn-star" src={sponsorStar} alt="" />
            <span>Sponsored by Adifund</span>
            <img className="adifund-card-btn-info" src={infoIcon} alt="" />
          </button>
        )}
      </div>
    </div>

    <p className="adifund-card-foot">
      Now extended to all
      <br />
      lovrican members
    </p>
  </div>
);

export default AdifundCard;
